<template>
  <div class="tw-bg-primary-opacity-1">
    <div class="tw-container tw-mx-auto tw-h-11 tw-flex tw-items-center breadcrumb-container" :class="customContainer">
      <QBreadcrumbs
        :active-color="activeColor"
      >
        <QBreadcrumbsEl
          v-for="item in items"
          :key="`breadcrumb-${item.url}`"
          :label="item.title"
          :to="item.path"
        />
      </QBreadcrumbs>
    </div>
  </div>
</template>

<script lang="ts" setup>
withDefaults(
  defineProps<{
    items?: BreadCrumb[];
    customContainer?: string;
    activeColor?: string;
  }>(),
  {
    items: () => [],
    customContainer: "",
    activeColor: "primary",
  },
);
</script>

<style scoped>
.breadcrumb-container :deep(.q-breadcrumbs__el) {
  color: var(--theme-color-primary) !important;
  transition: color 0.2s;
}

.breadcrumb-container :deep(.q-breadcrumbs__el:hover) {
  color: var(--q-secondary) !important;
}

.breadcrumb-container :deep(.q-breadcrumbs--last .q-breadcrumbs__el) {
  color: #555 !important;
}

.breadcrumb-container :deep(.q-breadcrumbs__separator) {
  color: #999 !important;
}

/* Mobile: single line with ellipsis */
.breadcrumb-container :deep(.q-breadcrumbs > .flex) {
  flex-wrap: nowrap !important;
  overflow: hidden;
}

.breadcrumb-container :deep(.q-breadcrumbs > .flex > *) {
  flex-shrink: 0;
  white-space: nowrap;
}

.breadcrumb-container :deep(.q-breadcrumbs--last) {
  flex-shrink: 1 !important;
  min-width: 0;
  overflow: hidden;
}

.breadcrumb-container :deep(.q-breadcrumbs--last .q-breadcrumbs__el) {
  display: block !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Desktop: full display */
@media (min-width: 1024px) {
  .breadcrumb-container :deep(.q-breadcrumbs > .flex) {
    flex-wrap: wrap !important;
    overflow: visible;
  }

  .breadcrumb-container :deep(.q-breadcrumbs > .flex > *) {
    flex-shrink: initial;
    white-space: normal;
  }

  .breadcrumb-container :deep(.q-breadcrumbs--last) {
    flex-shrink: initial !important;
    overflow: visible;
  }

  .breadcrumb-container :deep(.q-breadcrumbs--last .q-breadcrumbs__el) {
    display: inline-flex !important;
    overflow: visible;
    text-overflow: unset;
    white-space: normal;
  }
}
</style>
